import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useIsDesktop } from './useIsDesktop';

export const useFocusFirstPossibleElement = (
  mainContent: HTMLDivElement | null
) => {
  const { pathname } = useLocation();
  const isDesktop = useIsDesktop();

  useEffect(() => {
    if (!isDesktop) return;
    if (mainContent) {
      const focusableElements = mainContent.querySelectorAll('[tabindex="-1"]');
      if (focusableElements.length > 0)
        (focusableElements[0] as HTMLElement).focus();
    }
  }, [pathname, mainContent, isDesktop]);

  return null;
};
